import { render, staticRenderFns } from "./fontManage.vue?vue&type=template&id=51011554&"
import script from "./fontManage.vue?vue&type=script&lang=js&"
export * from "./fontManage.vue?vue&type=script&lang=js&"
import style0 from "./fontManage.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports